import classnames from 'classnames';
import React from 'react';
import Card, { CardContent } from '../Card';
import CircularProgress from '../CircularProgress';
import Grid from '../Grid';
import Tokens from '../styles/Tokens';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = createStyles({
    containerLoader: {
        height: Tokens.heightFluid,
        left: 0,
        top: 0,
        width: Tokens.widthFluid
    },
    itemLoading: {
        textAlign: 'center',
        verticalAlign: 'middle'
    },
    lgHeight: {
        height: '600px'
    },
    mdHeight: {
        height: '400px'
    },
    smHeight: {
        height: '200px'
    }
});
const ContainerLoader = (props) => {
    const { classes, height, id, withCard } = props;
    let classContainer = classes.containerLoader;
    if (height) {
        switch (height) {
            case 'sm':
                classContainer = classnames(classContainer, classes.smHeight);
                break;
            case 'md':
                classContainer = classnames(classContainer, classes.mdHeight);
                break;
            case 'lg':
                classContainer = classnames(classContainer, classes.lgHeight);
                break;
        }
    }
    let content = (React.createElement(Grid, { container: true, alignContent: "center", className: classContainer, direction: "column", justify: "center", id: id, spacing: 1 },
        React.createElement(Grid, { item: true, className: classes.itemLoading },
            React.createElement(CircularProgress, { id: id, size: 30, role: "progressbar" }))));
    if (withCard) {
        content = (React.createElement(Card, null,
            React.createElement(CardContent, null, content)));
    }
    return content;
};
ContainerLoader.defaultProps = {
    height: 'md',
    id: '',
    withCard: false
};
export default withStyles(styles)(ContainerLoader);
